import React, { ReactElement } from 'react';
import JoinActionButton from '../JoinActionButton';
import { DashlineSeparator } from '../styledElements';
import { HeadlineContainer, ThankYouDescription } from './SelfieVerificationStyle';
import { Headline } from '../JoinStyle';
import { SITE_NAME } from '../../../config/Master';

const ThankYouStep: React.FC<{ handleNextClick: () => void }> = ({ handleNextClick }): ReactElement => {
  return (
    <HeadlineContainer style={{ justifyContent: 'center', marginTop: 0, minHeight: 520, width: '100%' }}>
      <Headline>Success!</Headline>
      <ThankYouDescription>
        {`Thank you for verifying with a selfie and helping to keep ${SITE_NAME} a safer place!`}
      </ThankYouDescription>
      <ThankYouDescription>Press Next to continue.</ThankYouDescription>
      <DashlineSeparator style={{ marginTop: 20, marginBottom: 0, width: '100%' }} />
      <div style={{ textAlign: 'center' }}>
        <JoinActionButton label="Next" isDefault={true} onClick={handleNextClick} customStyle={{ marginBottom: 20 }} />
      </div>
    </HeadlineContainer>
  );
};

export default ThankYouStep;
